module.exports = {"1054x1054": __webpack_public_path__ + "images/escape-ring-1054x1054.png"};